import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "./MiniWidgets";
import RevenueAnalytics from "./RevenueAnalytics";
import SalesAnalytics from "./SalesAnalytics";
import EarningReports from "./EarningReports";
import { FetchDashboardStats } from "../../apis/Dashboard";
import { formatCount, formatRate } from "./format";

const EMPTY_RANGE = {
  labels: [],
  currentName: "Current",
  previousName: "Previous",
  current: [],
  previous: [],
};

const reportCard = (icon, title, summary, details = []) => ({
  icon,
  title,
  value: formatCount(summary?.total),
  rate: formatRate(summary?.changePercent),
  direction: summary?.direction || "flat",
  desc: "From previous 30 days",
  details,
});

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Nazox", link: "/" },
        { title: "Dashboard", link: "#" },
      ],
      reports: [
        reportCard("ri-user-line", "Total users", null, [
          { value: 0, label: "hosts" },
          { value: 0, label: "guests" },
        ]),
        reportCard("ri-store-2-line", "Total reservations", null, [
          { value: 0, label: "staying now" },
          { value: 0, label: "upcoming" },
        ]),
        reportCard("ri-checkbox-circle-line", "Listed on the site"),
        reportCard("ri-stack-line", "All listings", null, [
          { value: 0, label: "not listed" },
          { value: 0, label: "still being set up" },
        ]),
      ],
      revenue: {
        thisMonth: { amount: 0, changePercent: 0, direction: "flat" },
        thisYear: { amount: 0, changePercent: 0, direction: "flat" },
        previousYear: { amount: 0 },
        ranges: {
          today: EMPTY_RANGE,
          week: EMPTY_RANGE,
          month: EMPTY_RANGE,
        },
      },
      sales: {
        slices: [
          { key: "completed", label: "Paid" },
          { key: "pending", label: "Pending" },
          { key: "failed", label: "Failed" },
        ],
        months: [],
      },
      earnings: {
        weekly: { amount: 0, percent: 0 },
        monthly: { amount: 0, percent: 0 },
      },
    };
  }

  componentDidMount() {
    this.fetchDashboardStats();
  }

  fetchDashboardStats = async () => {
    try {
      const response = await FetchDashboardStats();
      if (!response?.success || !response.data) {
        console.error(
          "Failed to fetch dashboard stats:",
          response?.message,
        );
        return;
      }

      const { summary, revenue, sales, earnings } = response.data;
      this.setState({
        reports: [
          reportCard("ri-user-line", "Total users", summary?.users, [
            { value: summary?.users?.hosts, label: "hosts" },
            { value: summary?.users?.guests, label: "guests" },
          ]),
          reportCard(
            "ri-store-2-line",
            "Total reservations",
            summary?.reservations,
            [
              { value: summary?.reservations?.staying, label: "staying now" },
              { value: summary?.reservations?.upcoming, label: "upcoming" },
            ],
          ),
          reportCard(
            "ri-checkbox-circle-line",
            "Listed on the site",
            summary?.listedListings,
            [{ label: "Guests can book these" }],
          ),
          reportCard("ri-stack-line", "All listings", summary?.listings, [
            { value: summary?.listings?.notListed, label: "not listed" },
            {
              value: summary?.listings?.inProgress,
              label: "still being set up",
            },
          ]),
        ],
        revenue: revenue || this.state.revenue,
        sales: sales || this.state.sales,
        earnings: earnings || this.state.earnings,
      });
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid className="px-4">
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col xl={8}>
                <Row>
                  <MiniWidgets reports={this.state.reports} />
                </Row>
                <RevenueAnalytics revenue={this.state.revenue} />
              </Col>
              <Col xl={4}>
                <SalesAnalytics
                  slices={this.state.sales.slices}
                  months={this.state.sales.months}
                />
                <EarningReports earnings={this.state.earnings} />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
